import {
  createUserPlanPlanCreateLessonIdGetQueryKey,
  getLessonListLessonLessonIdGetQueryKey,
  getUserPlanPlanAllUserPlansGetQueryKey,
  updateUserPlanPlanUpdatePostMutation,
} from '@/client/@tanstack/react-query.gen'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { logger } from '@/utils'
import { useAuthHeaders } from '@/providers'

const log = logger.child({
  file: 'src/hooks/mutations/useUpdateUserLessonPlan.tsx',
})

export type useUpdateUserLessonPlanProps = {
  lessonId: string
}

export const useUpdateUserLessonPlanMutation = ({
  lessonId,
}: useUpdateUserLessonPlanProps) => {
  const headers = useAuthHeaders()
  const queryClient = useQueryClient()
  return useMutation({
    ...updateUserPlanPlanUpdatePostMutation({ headers }),
    onSuccess(body) {
      log.info({ msg: 'User lesson plan updated successfully', data: { body } })
      // invalidate userLessonPlan query to get the latest data
      // Invalidate each query separately
      queryClient.invalidateQueries({
        queryKey: getUserPlanPlanAllUserPlansGetQueryKey(),
      })

      queryClient.invalidateQueries({
        queryKey: getLessonListLessonLessonIdGetQueryKey({
          path: { lesson_id: lessonId },
        }),
      })

      queryClient.invalidateQueries({
        queryKey: createUserPlanPlanCreateLessonIdGetQueryKey({
          path: { lesson_id: lessonId },
        }),
      })
    },
    onError: (error) => {
      log.error({ msg: 'Error updating user lesson plan', data: { error } })
    },
  })
}
